import Script from "next/script";
import React from "react";

import gtag from './helpers/gtag';

const analyticsKey = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_KEY;

const GoogleAnalytics = () => {
    if (!analyticsKey) {
        return null;
    }

    return (
        <Script
            id="google-analytics"
            strategy="afterInteractive"
            src={`https://www.googletagmanager.com/gtag/js?id=${analyticsKey}`}
            onLoad={() => {
                window.dataLayer = window.dataLayer || [];
                gtag("js", new Date());
                gtag("config", analyticsKey);
            }}
        />
    );
};

export default GoogleAnalytics;
